Monitoring.Views ||= {}

class Monitoring.Views.MovistarRuleEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_rule_edit_modal"]

  events:
    'click .save': 'onClickSave'

  initialize: (@options = {}) ->
    @rule            = @options.rule
    @availableTags   = @options.availableTags
    @availableSubtypes = @options.availableSubtypes
    @currentUser = @options.currentUser
    @accountId = @options.accountId

  render: ->
    @$el.html(@template({ accountId: @accountId }))
    @renderGeneralTab()
    @renderConditionTab()
    @renderActionsTab()
    @renderIntervalsTab()
    @initializeChosen()
    @updateSaveButtonStatus()
    @

  renderGeneralTab: ->
    @ruleGeneralEditView = new Monitoring.Views.MovistarRuleGeneralEditView({
      rule: @rule
    })
    @$el.find('#general').html(@ruleGeneralEditView.render().el)
    @listenTo(@ruleGeneralEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderConditionTab: ->
    @conditionEditView = new Monitoring.Views.MovistarSocialContentConditionEditView({
      socialContentCondition: @rule.get('social_content_condition')
      availableTags: @availableTags
      availableSubtypes: @availableSubtypes
    })
    @$el.find('#condition').html(@conditionEditView.render().el)
    @listenTo(@conditionEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderActionsTab: ->
    @actionsEditView = new Monitoring.Views.MovistarActionsEditView({
      movistarAction: @rule.get('actions')[0]
    })
    @$el.find('#actions').html(@actionsEditView.render().el)
    @listenTo(@actionsEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderIntervalsTab: ->
    @intervalsListView = new Monitoring.Views.MovistarIntervalsListView({
      intervals: new Monitoring.Collections.MovistarRuleIntervalsCollection(@rule.get('intervals'))
    })
    @$el.find('#intervals').html(@intervalsListView.render().el)
    @listenTo(@intervalsListView, 'changed-mandatory-field', @updateSaveButtonStatus)

  viewsInTabs: ->
    # [@ruleGeneralEditView, @conditionEditView, @actionsEditView]
    [@ruleGeneralEditView, @conditionEditView, @intervalsListView]

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({
      width: '395px'
      enable_split_word_search: true
      search_contains: true
    });

  updateSaveButtonStatus: =>
    @$el.find('.save').prop('disabled', !@allMandatoryFieldsAreFilled())

  allMandatoryFieldsAreFilled: =>
    _.all(@viewsInTabs(), (view) -> view.allMandatoryFieldsAreFilled())

  onClickSave: (evt) ->
    $(evt.currentTarget).button('loading')
    @rule.set('social_content_condition', @conditionEditView.getConditionOfSelectedKind())
    @rule.set('actions', @actionsEditView.getActions())
    @rule.set('intervals', @intervalsListView.getIntervals())
    @rule.set('updated_at', new Date().toISOString())
    @rule.set('updated_by', @currentUser.full_name)
    @rule.set('start_date', @intervalsListView.getStartDate())
    @rule.set('end_date', @intervalsListView.getEndDate())
    errorOrValid = @rule.validateFields()
    if errorOrValid == "VALID"
      @$el.find('.saving').removeClass('invalid-fields')
      @rule.save({}, {
        success: (response) =>
          @redirectToIndex()
        error: (response) =>
          @$el.find('button.save').button('reset')
          @$el.find('.saving').html('Error')
          console.log("Error saving rule: #{response}")
      })
    else
      @$el.find('.saving').addClass('invalid-fields').html(errorOrValid).show()

  redirectToIndex: ->
    location.href = "/monitoring/movistar_rule_specifications?account_id=" + @accountId

